const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=commentsBody]');
import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {
  let iRemoveBlock = '';
  let newMsg = '';

  if (item.userWithNewMsg && parseInt(item.userWithNewMsg,10 ) > 0) 
    newMsg = 'little-icon-newCmt';

  if (parseInt(auth.data.operatorId, 10) === parseInt(item.uid,10))
    iRemoveBlock = ` <i class="mr-3" name="removeNote" noteID="${item.id}" >Удалить заметку</i>`;

  let userPhone = '';
  if(item.phone && item.phone > 2)
    userPhone = ': ' + tools.formatedPhone(item.phone) ;


  return `<div class = "commentCloud row "}>
            <b class="m-0 p-0 w-100">${item.comment}</b>
            <div class="ml-1 p-0 ">${item.name} ${userPhone}</div>
            <div class="ml-auto mr-1 p-0 ${newMsg}">${iRemoveBlock}${tools.dateStringFull(item.time)}</div>
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay) {

    this.cleanContainer();
    if(dataToDisplay)
      dataToDisplay.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    else
      htmlBody.innerHTML = `<div class = "commentCloud row "}>
            <b class="m-0 p-0 w-100">Заметок пока нет</b>
            <div class="ml-1 p-0 ">Заметки будут видны только вам и вашим коллегам-организаторам внутри данного фестиваля. <br>Данные заметки не будут видны отправителю заявки и прочим лицам.</div>
          </div>`;
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
